import React from "react";
import cs from "classnames";
import { Button as ReactstrapButton, ButtonProps, Spinner } from "reactstrap";

import { Icon } from "../Icon/Icon";
import { IconDefinition } from "../Icon/Icon.generated";

import "./Button.scss";

export type ButtonSize = "large" | "small" | "medium" | undefined;

export type LineHeight = "low" | "normal" | undefined;

export type ButtonColor =
  | "primary"
  | "secondary"
  | "third"
  | "business"
  | "pro"
  | "outline-secondary"
  | "outline-primary"
  | "outline-red"
  | "underline"
  | "simple"
  | "link"
  | undefined;

export interface ThemeButtonProps extends ButtonProps {
  icon?: IconDefinition;
  title?: string;
  subTitle?: string;
  size?: ButtonSize;
  className?: string;
  color?: ButtonColor;
  lineHeight?: LineHeight;
  loadSpinner?: boolean;
  loadTitle?: string;
  tooltip?: string;
  iconOnly?: boolean;
}

export const Button = (props: ThemeButtonProps) => {
  const {
    title,
    subTitle,
    className,
    color,
    icon,
    lineHeight,
    loadSpinner,
    loadTitle,
    tooltip,
    iconOnly,
    children,
    "aria-label": ariaLabel,
    ...rest
  } = props;
  const hasChildren = children !== undefined && children !== null;
  const button = (
    <ReactstrapButton
      {...rest}
      color={color || "primary"}
      aria-label={ariaLabel || (iconOnly ? tooltip : undefined)}
      className={cs(
        "Button",
        {
          "Button--icon": !!icon,
          "Button--low": lineHeight === "low",
          "Button--icon-only": iconOnly,
          "Button--has-tooltip": !!tooltip,
        },
        className
      )}
    >
      {hasChildren ? (
        children
      ) : (
        <>
          {icon && <Icon icon={icon} />}
          {loadSpinner && <Spinner size="sm" className="mr-2" />}
          {(!iconOnly || !!title || !!loadSpinner) && (
            <span>{loadSpinner ? loadTitle : title}</span>
          )}
          {subTitle && <span className="Button--subtitle">{subTitle}</span>}
        </>
      )}
    </ReactstrapButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <span
      className={cs("ButtonTooltip", {
        "ButtonTooltip--full-width": className?.split(/\s+/).includes("w-100"),
      })}
    >
      {button}
      <span className="Button__tooltip">{tooltip}</span>
    </span>
  );
};
